<template>
	<div :class="$style['app-header-account']">
		<div
			v-if="user"
			v-testid="'account-menu-toggle'"
			:class="$style['app-header-account__content']"
			@click="!$breakpoints.sm ? toggleDropdown() : toggle()"
		>
			<Avatar
				:id="user.id"
				:picture="pictureUrl"
				:credentials="initials"
				:disabled="true"
				:fullname="displayName"
				:class="$style['app-header-account__avatar']"
			/>

			<div :class="$style['app-header-account__details']">
				<div :class="$style['app-header-account__details-text']">
					<span v-testid="'account-user-name'">{{ displayName }}</span>
					<small v-testid="'current-department'">{{ selectedDepartmentName }}</small>
				</div>
				<FontAwesomeIcon
					v-if="!$breakpoints.sm"
					:icon="['fal', 'angle-down']"
					:class="[
						$style['app-header-account__arrow-down'],
						!expanded && $style['app-header-account__arrow-down--collapsed']
					]"
				/>
				<BaseIconButton
					v-else
					:class="[$style['collapsible__icon'], {
						[$style['collapsible__icon--collapsed']]: !expanded,
						[$style['collapsible__icon--in-transition']]: inTransition
					}]"
					@click="toggle"
				>
					<FontAwesomeIcon :icon="['fal', 'angle-down']" />
				</BaseIconButton>
			</div>
		</div>

		<DropdownMenu
			v-if="user && !$breakpoints.sm"
			ref="dropdown"
			test-id="account-menu"
			:class="$style['app-header__dropdown']"
			@close="expanded=false"
		>
			<ul
				v-for="(list, index) in filteredLists"
				:key="index"
				:class="$style['app-header__dropdown-list']"
			>
				<DropdownMenuItem
					v-for="(item, index2) in list"
					:key="item.title + index2"
					:item="item"
				/>
			</ul>
		</DropdownMenu>
		<div
			v-else-if="user"
			ref="content"
			:class="[$style['collapsible__content'], {
				[$style['collapsible__content--in-transition']]: inTransition,
				[$style['collapsible__content--collapsed']]: !expanded
			}]"
		>
			<ul
				v-for="(list, index) in filteredLists"
				:key="index"
				:class="$style['app-header__dropdown-list']"
			>
				<DropdownMenuItem
					v-for="(item, index2) in list"
					:key="item.title + index2"
					:item="item"
				/>
			</ul>
		</div>
	</div>
</template>
<script>
import Avatar from '@/components/Essentials/Avatar'
import DropdownMenu from '@c:essentials/DropdownMenu'
import DropdownMenuItem from '@c:essentials/DropdownMenu/DropdownMenuItem'
import '@/store/modules/Parts/helpers'

import { createNamespacedHelpers } from 'vuex'
import collapsible from '@/mixins/collapsible'
const { mapGetters } = createNamespacedHelpers('Auth')
import breakpoints from '@/mixins/breakpoints'


export default {
	name: 'AppHeaderAccount',
	components: {
		Avatar,
		DropdownMenu,
		DropdownMenuItem
	},
	mixins: [breakpoints, collapsible],
	computed: {

		...mapGetters({
			user: 'user',
			selectingDepartmentId: 'selectingDepartmentId'
		}),

		lists () {
			return [
				[
					{
						title: this.$t('app-header.fields.user-settings'),
						to: { name: 'Dashboard:Account' },
						show: true,
						leadingIcon: 'fal cogs'
					},
					{
						title: this.$t('app-header.fields.change-password'),
						to: { name: 'Dashboard:Account:ChangePassword' },
						show: true,
						leadingIcon: 'fal unlock'
					}
				],
				this.departments,
				[
					{
						title: this.$t('app-header.fields.category-sets'),
						to: { name: 'Dashboard:CategorySets' },
						show: this.$can('CREATE_CATEGORY_SET'),
						leadingIcon: 'fal stream'
					},
					{
						title: this.$t('app-header.fields.condition-types'),
						to: { name: 'Dashboard:ConditionTypes' },
						show: this.$can('VIEW_VEHICLES'),
						leadingIcon: 'fal layer-group'
					},
					{
						title: this.$t('app-header.fields.category-groups'),
						to: { name: 'Dashboard:PartCategoryGroups' },
						show: this.$can('CREATE_CATEGORY_SET'),
						leadingIcon: 'fal folder-tree'
					},
					{
						title: this.$t('app-header.fields.vehicles'),
						to: { name: 'Dashboard:Vehicles' },
						show: this.$can('VIEW_VEHICLES'),
						leadingIcon: 'fal car-side'
					},
					{
						title: this.$tc('common.titles.plan', 2),
						to: { name: 'Dashboard:Plans' },
						show: this.$can('ACTIVATE_PLAN'),
						leadingIcon: 'fal file-signature'
					}
				],
				[
					{
						title: this.$t('app-header.fields.logout'),
						to: { name: 'Auth:Logout' },
						danger: true,
						show: true,
						icon: 'far sign-out'
					}
				]
			]
		},

		filteredLists () {
			return this.lists.map(list => {
				return list.filter(_list => _list.show)
			}).filter(list => list.length)
		},

		departments () {
			if (this.user && this.user.departments) {
				return this.user.departments.map(department => {
					return {
						title: department.name,
						show: true,
						// leadingIcon: 'fal warehouse',
						icon: (this.user.selectedDepartmentId === department.id) ? 'far check' : false,
						isLoading: this.selectingDepartmentId === department.id,
						click: async (_e) => {
							// if (this.$store.getters['App/Cart/cart']?.id) {
							// 	this.$store.dispatch('App/Cart/DELETE_CART', { id: this.$store.getters['App/Cart/cart'].id })
							// }
							if (this.$auth()?.selectedDepartmentId === department.id) {
								// this.$store.commit('Parts/SET_SHOWING', 'all' )
								this.$store.commit('Parts/SET_SHOWING', 'department' )
								await this.$store.dispatch('Auth/SET_DEPARTMENT', {
									selectedCompany: null,
									selectedDepartment: null
								})
							} else {
								this.$store.commit('Parts/SET_SHOWING', 'department' )
								this.$store.dispatch('Auth/SET_DEPARTMENT', {
									selectedCompany: department.companyId,
									selectedDepartment: department.id
								})
							}
							// this.$store.dispatch('Orders/FETCH_ORDER_TYPES', { departmentId: this.$auth().selectedDepartmentId === department.id ? null : department.id }, { root: true })
						}
					}
				})
			} else {
				return []
			}
		},

		selectedDepartmentName () {
			const auth = this.$auth()
			if (!auth || !auth.departments) {
				return null
			}
			const dep = auth.departments.find(department => department.id === auth.selectedDepartmentId)
			return dep ? dep.name : null
		},

		initials () {
			return this.user?.firstname?.[0] && this.user?.lastname?.[0]
				? this.user.firstname[0] + this.user.lastname[0]
				: ''
		},

		displayName () {
			return `${this.user?.firstname || ''} ${this.user?.lastname || ''}`.trim()
		},

		pictureUrl () {
			return this.user?.picture?.url || null
		}
	},
	methods: {

		toggleDropdown () {
			this.$refs['dropdown'].toggle()
			this.expanded = !this.expanded
		}

	}
}
</script>
<style lang="scss" module>

.app-header-account {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 230px;
    border-left: 1px solid getColor(border);
    border-right: 1px solid getColor(border);
    padding: 0 20px;
    height: 100%;
    transition: background-color 0.15s ease;

    @include media-breakpoint-down(sm) {
        min-width: 100%;
        border-left: none;
        border-right: none;
        padding-right: 20px;
        box-shadow: 0 0 3px 0 getColor(shadow-light);
    }

    &:hover {
        cursor: pointer;
        background-color: getColor(hover-overlay);
    }

    &__content {
        display: flex;
        align-items: center;
        user-select: none;
        background-color: transparent;
        transition: background-color 0.2s ease;
        font-size: 14px;
        color: getColor(text);
        flex: 1;
        padding: 5px 0;
        border-radius: 5px;
    }

    &__avatar {
        height: 35px;
        width: 35px;
        font-size: 18px;
        margin-right: 10px;
        flex-shrink: 0;
    }

    &__details {
        display: flex;
        align-items: center;
        flex: 1;
        min-width: 0;

        &-text {
            display: flex;
            flex-flow: column;
            flex: 1;
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    &__arrow-down {
        font-size: 18px;
        color: getColor(icon);
        transform: rotate(-180deg);
        transition: transform 0.2s ease-in-out, color 0.15s ease;
        flex-shrink: 0;
        margin-left: 8px;

        &--collapsed {
            transform: rotate(0);
        }

        .app-header-account:hover & {
            color: getColor(icon-active);
        }
    }
}

.app-header__dropdown {
    z-index: 2;
    top: 100%;
    transform-origin: top;
    width: 100%;
    background-color: getColor(surface-elevated);
    border: 1px solid getColor(border);
    border-radius: 4px;
    box-shadow: 0 4px 12px getColor(shadow);
    margin-top: 1px;

    @include dark-mode-border-fix(border);

    &-list {
        list-style: none;
        margin: 0;
        padding: 0;
        max-height: 300px;
        overflow: auto;

        @include media-breakpoint-down(sm) {
            max-height: 200px;
        }

        &:not(:first-child) {
            border-top: 1px solid getColor(border);
        }

        // Custom scrollbar
        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-track {
            background: getColor(surface);
        }

        &::-webkit-scrollbar-thumb {
            background: getColor(border-secondary);
            border-radius: 3px;

            &:hover {
                background: getColor(primary);
            }
        }
    }
}

.collapsible {
    padding: 0;

    &__icon {
        font-size: 16px;
        cursor: pointer;
        color: getColor(icon);
        transform: rotate(-180deg);
        transition: color 0.15s ease;

        &:hover {
            color: getColor(icon-active);
        }

        &--collapsed {
            transform: rotate(0);
        }

        &--in-transition {
            transition: transform 0.2s ease-in-out, color 0.15s ease;
        }
    }

    &__content {
        z-index: 999999;
        position: absolute;
        top: 60px;
        width: 100%;
        height: 100vh;
        background-color: getColor(surface);
        box-shadow: 0 2px 8px getColor(shadow);

        &--collapsed {
            overflow: hidden;
            height: 0;
        }

        &--in-transition {
            transition: height 0.2s ease-in-out;
            will-change: height;
            overflow: hidden;
        }
    }
}

</style>
